import React from 'react';

import {
    box,
    CONTENT_WIDTH,
    MARGIN_X,
    pt,
    STATUS_HEADER_HEIGHT,
    STATUS_LINE_GAP,
    STATUS_TEXT_LINE_HEIGHT,
    statusIntroHeight,
    statusLineHeights,
    statusLinesHeight,
} from '../slideGeometry';

const INSET_X = 16;

/**
 * A block's status rule lines under its heading ("Status rules" without one) and the block's
 * introduction, starting `top` px into their container: the introduction and
 * each rule at full width in the slot the Paginator measured for it, over
 * every line its text wraps to, as in the .pptx.
 */
export const StatusLines = ({ block, top }) => {
    const lines = block.statusLines || [];
    const slots = statusLineHeights(block);

    if (!lines.length) {
        return null;
    }

    const introTop = top + STATUS_HEADER_HEIGHT;
    const introHeight = statusIntroHeight(block);
    let y = introTop + introHeight;
    const rows = lines.map((line, index) => {
        const row = { line, index, y, height: slots[index] - STATUS_LINE_GAP };
        y += slots[index];

        return row;
    });

    return (
        <>
            <div className="tw-text-dark-blue tw-font-bold" style={{ ...box(INSET_X, top, 300, STATUS_HEADER_HEIGHT), fontSize: pt(9) }}>
                {block.heading || $t('Status rules')}
            </div>
            {introHeight > 0 && (
                <p
                    className="tw-m-0 tw-text-charcoal"
                    dir="auto"
                    style={{
                        ...box(INSET_X, introTop, CONTENT_WIDTH - 2 * INSET_X, introHeight - STATUS_LINE_GAP),
                        fontSize: pt(8),
                        lineHeight: `${STATUS_TEXT_LINE_HEIGHT}px`,
                    }}
                >
                    {block.statusIntro}
                </p>
            )}
            {rows.map(({ line, index, y: lineY, height }) => (
                <p
                    key={index}
                    className="tw-m-0 tw-text-charcoal"
                    dir="auto"
                    style={{
                        ...box(INSET_X, lineY, CONTENT_WIDTH - 2 * INSET_X, height),
                        fontSize: pt(8),
                        lineHeight: `${STATUS_TEXT_LINE_HEIGHT}px`,
                    }}
                >
                    <span className="tw-font-bold tw-text-charcoal-60">{line.label}: </span>
                    {line.value}
                </p>
            ))}
        </>
    );
};

/**
 * A page's own status rules block, drawn like the basis block's status lines.
 */
const StatusRulesBlock = ({ block }) => {
    const height = block.height ?? statusLinesHeight(block);

    return (
        <div style={box(MARGIN_X, block.y, CONTENT_WIDTH, height)}>
            <StatusLines block={block} top={0} />
        </div>
    );
};

export default StatusRulesBlock;
